import React, { useCallback } from 'react';
import { Box, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import MovieIcon from '@mui/icons-material/Movie';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import ChatIcon from '@mui/icons-material/Chat';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useHoverNavigation from '../use-hover-navigation';
import { hoverHighlightSx } from '../hover-style';

const topics = [
    { key: 'news', icon: NewspaperIcon, color: '#1976d2' },
    { key: 'entertainment', icon: MovieIcon, color: '#9c27b0' },
    { key: 'medical', icon: LocalHospitalIcon, color: '#2e7d32' },
    { key: 'discussion', icon: ChatIcon, color: '#ed6c02' },
];

const ITEMS_COUNT = 5; // 4 topics + Back

const panelSx = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    userSelect: 'none',
    transition: 'box-shadow 0.3s ease, filter 0.3s ease',
    borderRadius: 4,
    p: 3,
};

export default function TopicScreen({ onSelectTopic }) {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const onSelect = useCallback((index) => {
        if (index < topics.length) {
            onSelectTopic(topics[index].key);
        } else {
            navigate('/main/applications');
        }
    }, [navigate, onSelectTopic]);

    const { active, activeIndex } = useHoverNavigation(ITEMS_COUNT, onSelect);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
            <Box sx={{ flex: '1 1 80%', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, p: 2, minHeight: 0 }}>
                {topics.map((topic, index) => {
                    const Icon = topic.icon;
                    const isHovered = active && activeIndex === index;
                    return (
                        <Box
                            key={topic.key}
                            onClick={() => onSelectTopic(topic.key)}
                            sx={{
                                ...panelSx,
                                border: '4px solid',
                                borderColor: topic.color,
                                color: topic.color,
                                ...(isHovered && hoverHighlightSx),
                            }}
                        >
                            <Icon sx={{ fontSize: 64, mb: 1 }} />
                            <Typography variant="h5" sx={{ fontWeight: 700 }}>
                                {t(`APPLICATIONS.BUDDY.TOPICS.${topic.key.toUpperCase()}`)}
                            </Typography>
                            <Typography variant="body1" color="text.secondary" sx={{ mt: 1, textAlign: 'center' }}>
                                {t(`APPLICATIONS.BUDDY.TOPICS.${topic.key.toUpperCase()}_DESC`)}
                            </Typography>
                        </Box>
                    );
                })}
            </Box>

            <Box
                onClick={() => navigate('/main/applications')}
                sx={{
                    ...panelSx,
                    flex: '0 0 15%',
                    flexDirection: 'row',
                    gap: 1,
                    bgcolor: 'grey.300',
                    color: 'text.primary',
                    m: 2,
                    ...(active && activeIndex === 4 && hoverHighlightSx),
                }}
            >
                <ArrowBackIcon sx={{ fontSize: 40 }} />
                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                    {t('APPLICATIONS.BACK')}
                </Typography>
            </Box>
        </Box>
    );
}
